import appGlobalScript from '/tmp/scratch/ticom-feature-components_LdPDq/src/global/index.ts';
export const globalScripts = appGlobalScript;
